import React from 'react';
import './App.css';
import Routes from './routes/Routes';
import { AppAlerts } from './components';
import { appGetAnalytics } from './utils/analytics';

appGetAnalytics();

function App() {
  // const {t} = useTranslation();

  return (
    <>
      <AppAlerts />
      <Routes />
    </>
  );
}

export default App;
